/**
 * Returns an iterator of pairs of consecutive elements from the input iterable.
 * @example
 * pairwise('ABCDEFG') → ['AB', 'BC', 'CD', 'DE', 'EF', 'FG']
 */
export function* pairwise<T>(iterable: Iterable<T>): Generator<[T, T], void, unknown> {
  const iterator = iterable[Symbol.iterator]()
  let a = iterator.next()
  if (a.done) return
  let b = iterator.next()
  while (!b.done) {
    yield [a.value, b.value]
    a = b
    b = iterator.next()
  }
}
